import { combineReducers } from 'redux';
import searchReducer from './searchReducer';

/**
 * Combine reducers here
 */
export default combineReducers<RootState>({
	search: searchReducer,
});
